import {activityPeriod,shiftDate} from './activity-model.js';
// Records use observed days only. Missing reports are not zero activity.
export function fitnessInsights(days) {
  const measured = key => days.filter(d => typeof d[key] === "number" && Number.isFinite(d[key]) && d[key] >= 0);
  const average = key => { const values = measured(key); return values.length ? values.reduce((sum, d) => sum + d[key], 0) / values.length : null; };
  const best = key => measured(key).reduce((winner, d) => !winner || d[key] > winner.value ? { date: d.date, value: d[key] } : winner, null);
  const stepDays = measured("steps"), active = days.filter(d => d.distanceKm !== null && d.distanceKm > 0);
  return { averageSteps: average("steps"), averageDistanceKm: average("distanceKm"), averageCalories: average("calories"),
    averageActiveMinutes: average("activeMinutes"), stepDays: stepDays.length, activeDays: active.length,
    bestStepDay: best("steps"), bestDistanceDay: best("distanceKm"), bestActiveDay: best("activeMinutes"), peakGps: best("peakGpsSpeedKph") };
}
/** @returns {Array<{key:string,value:number|null,observed:number,total:number}>} */
export function fitnessChart(days, period) {
  if (period !== "year") return days.map(d => ({ key: d.date, value: d.steps, observed: d.steps === null ? 0 : 1, total: 1 }));
  const months = new Map();
  for (const day of days) {
    const key = day.date.slice(0, 7), value = months.get(key) ?? { key, value: null, observed: 0, total: 0 };
    value.total++;
    if (day.steps !== null) { value.observed++; value.value = (value.value ?? 0) + day.steps; }
    months.set(key, value);
  }
  return [...months.values()];
}

// Calendar ranges (including leap years and Copenhagen DST) are shared with the API.
export function previousActivityAnchor(period,anchor){return shiftDate(activityPeriod(period,anchor).startDate,-1);}
export function compareFitnessDays(current,previous){
 const observed=(days,key)=>days.map(d=>d[key]).filter(v=>typeof v==='number'&&Number.isFinite(v)&&v>=0);
 return Object.fromEntries(['steps','distanceKm','calories','activeMinutes'].map(key=>{
  const a=observed(current,key),b=observed(previous,key),mean=v=>v.length?v.reduce((x,y)=>x+y,0)/v.length:null;
  const now=mean(a),before=mean(b),difference=now===null||before===null?null:now-before;
  return [key,{current:now,previous:before,currentDays:a.length,previousDays:b.length,difference,
   percent:difference===null||before===0?null:difference/before*100}];
 }));
}
